/*
 * @Author: Zhouqi
 * @Date: 2026-01-21 14:56:31
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-21 15:48:23
 */
import React from 'react';

export interface VerificationErrorProps {
  /** 错误信息 */
  message?: string;

  /** 关闭回调(可选) */
  onClose?: () => void;
}

/**
 * 验证错误提示组件
 *
 * 简单的错误提示条,显示在组件顶部
 *
 * @example
 * ```tsx
 * <VerificationError
 *   message="验证失败,请重试"
 *   visible={!!verificationError}
 *   onClose={() => setVerificationError(null)}
 * />
 * ```
 */
export const VerificationError: React.FC<VerificationErrorProps> = ({
  message = 'Please complete the security check',
  onClose,
}) => {
  return (
    <div
      className="verification-error"
      style={{
        backgroundColor: '#FEE2E2',
        color: '#DC2626',
        padding: '12px 16px',
        minHeight: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '4px',
        marginBottom: '16px',
        fontSize: '14px',
        lineHeight: '1.5',
        animation: 'fadeIn 300ms ease-in-out',
      }}
    >
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#DC2626',
            cursor: 'pointer',
            fontSize: '18px',
            padding: '0 4px',
            marginLeft: '12px',
            lineHeight: 1,
          }}
          aria-label="Close"
        >
          ×
        </button>
      )}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default VerificationError;
